<div class="buttons__div">
  <div class="div__input__file">
    <div *ngIf="!disablePDF" class="botao__input__file" (click)="OnClickApplyPDFButton.emit()">
      <input type="file" class="input__file">
      <img src="assets/images/simbolos/downloadBlue.svg" />
      <label class="titulo__input__file">PDF</label>
    </div>
    <div *ngIf="!disableCSV" class="botao__input__file" (click)="OnClickApplyCSVButton.emit()">
      <input type="file" class="input__file">
      <img src="assets/images/simbolos/downloadBlue.svg" />
      <label class="titulo__input__file">CSV</label>
    </div>
    <div *ngIf="!disableXLSX" class="botao__input__file" (click)="OnClickApplyXLSXButton.emit()">
      <input type="file" class="input__file">
      <img src="assets/images/simbolos/downloadBlue.svg" />
      <label class="titulo__input__file">XLSX</label>
    </div>
  </div>
</div>
